'use strict';

/**
 *
 * @name: nownessApp.playlist
 *
 */

import PlaylistConfig from './playlist.config';

import PlaylistAnalyticsFactory from './playlist-analytics.factory';

import NnCuratedByMembersDirective from './nn-curated-by-members/nn-curated-by-members.directive';
import NnPlaylistGroupDirective from './nn-playlist-group/nn-playlist-group.directive';
import PlaylistOverlayDirectiveDEPRECATED from './playlist-overlay-DEPRECATED.directive';
import NnPlaylistOverlayDirective from './nn-playlist-overlay/nn-playlist-overlay.directive';
import NnSinglePlaylistDirective from './nn-single-playlist/nn-single-playlist.directive';

const PlaylistModule = angular
  .module('nownessApp.playlist', [])
  .config(PlaylistConfig)
  .factory('playlistAnalytics', PlaylistAnalyticsFactory)
  .directive('nnCuratedByMembers', NnCuratedByMembersDirective)
  .directive('nnPlaylistGroup', NnPlaylistGroupDirective)
  .directive('playlistOverlay', PlaylistOverlayDirectiveDEPRECATED)
  .directive('nnPlaylistOverlay', NnPlaylistOverlayDirective)
  .directive('nnSinglePlaylist', NnSinglePlaylistDirective);

export default PlaylistModule.name;



// WEBPACK FOOTER //
// ./app/pages/playlist/playlist.module.js